import { selectLocale } from '@termly-web/common'

import Termly from 'termly-namespace'

import client from 'utils/client'
import { getCookie, uuidCookie } from 'utils/cookie'
import CookieConsents from 'utils/cookieConsents'
import URL from 'utils/url'

import { triggerGetUpdatedCookieWhitelistByTermly } from 'utils/updateCookieConsent'


export default function fetchAndApplyCookieList({ cookieConsent, cookiePolicy, regionSetting }) {
  if ( !cookiePolicy ) {
    return
  }

  const uuidFromCookie = getCookie(uuidCookie)

  const locale = selectLocale({
    preferredLocales: window.navigator.languages,
    supportedLocales: regionSetting.language_setting,
  })

  const url = URL.getCookies({
    locale,
    region: regionSetting.region,
  })

  client.get(url)
    .then(({ data }) => {
      const { cookies } = data

      triggerGetUpdatedCookieWhitelistByTermly({
        consentMode: regionSetting.consent_mode,
        consentState: CookieConsents.getConsentSettings(),
        cookieConsent,
        cookies,
        visitorId: uuidFromCookie,
      })

      // We have to put the cookies *somewhere* so that when we invoke
      // `triggerGetUpdatedCookieWhitelistByTermly()` in `updateCookieConsent()`,
      // we can pass them along again. This feels really gross, but what was here
      // originally was storing them directly on the `window`, which is worse.
      // I'd like to come up with a sexier way to handle this, but that's out of
      // scope for the current round of work.
      Termly.cookies = cookies
    })
    .catch((err) => {
      console.warn('[Termly] error fetching cookie list: %o', err)
    })
}
